export const ai = "1:242689127574:web:e1cc90d295b5d039a0beb7"